import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../links/Link/Link';
import { useTranslation } from 'react-i18next';

/**
 * A component for displaying contact and social information
 */
function ContactLinks({
  supportText,
  phoneNumber,
  contactEmailAddress,
  webchatHref,
  bslHref,
  socialMediaText,
  xHref,
  facebookHref,
  linkedInHref,
  youTubeHref,
  instagramHref,
  feedbackEmailAddress,
  onOpenWebchat
}) {
  const { t } = useTranslation();

  return (
    <div className="footer__content">
      <div className="content__social">
        <div className="social__content">
          <div className="content__column column--50">
            <h2>
              {supportText}
              <Link href={`tel:${phoneNumber.replace(/\s+/g, '')}`}>{phoneNumber}</Link>
            </h2>
            <Link href={`mailto:${contactEmailAddress}`} className="social social--contact-email">
              {contactEmailAddress}
            </Link>
            <Link href={webchatHref} className="social social--contact-webchat" onClick={onOpenWebchat}>
              {t('styleguide:layout.footer.webchat.title')}
            </Link>
            <Link href={bslHref} className="social social--contact-bsl">
              {t('styleguide:layout.footer.bsl.title')}
            </Link>
          </div>
          <div className="content__column column--50">
            <h2>{socialMediaText}</h2>
            <Link href={instagramHref} target="_self" className="social social--instagram">
              Instagram
            </Link>
            <Link href={facebookHref} target="_self" className="social social--facebook-simple">
              Facebook
            </Link>
            <Link href={linkedInHref} target="_self" className="social social--linkedin-simple">
              LinkedIn
            </Link>
            <Link href={youTubeHref} target="_self" className="social social--youtube">
              YouTube
            </Link>
            <Link href={xHref} target="_self" className="social social--xcom">
              X
            </Link>
          </div>
        </div>
      </div>
      <div className="feedback__content">
        <Link href={`mailto:${feedbackEmailAddress}`} className="content__give-feedback">
          {t('styleguide:give_feedback')}
        </Link>
      </div>
    </div>
  );
}

ContactLinks.propTypes = {
  /**
   * The support text
   */
  supportText: PropTypes.string,
  /**
   * The phone number
   */
  phoneNumber: PropTypes.string,
  /**
   * The contact email address
   */
  contactEmailAddress: PropTypes.string,
  /**
   * The webchat link
   */
  webchatHref: PropTypes.string,
  /**
   * The BSL link
   */
  bslHref: PropTypes.string,
  /**
   * The social media text
   */
  socialMediaText: PropTypes.string,
  /**
   * The X link
   */
  xHref: PropTypes.string,
  /**
   * The facebook link
   */
  facebookHref: PropTypes.string,
  /**
   * The LinkedIn link
   */
  linkedInHref: PropTypes.string,
  /**
   * The YouTube link
   */
  youTubeHref: PropTypes.string,
  /**
   * The Instagram link
   */
  instagramHref: PropTypes.string,
  /**
   * The feedback email address
   */
  feedbackEmailAddress: PropTypes.string,
  /**
   * The open webchat handler
   */
  onOpenWebchat: PropTypes.func
};

export default ContactLinks;
